export enum Player {
  BITMOVIN = 'bitmovin',
  BITMOVIN_PWX = 'bitmovin-pwx',
  CHROMECAST_SHAKA = 'chromecast-shaka',
  HLSJS = 'hlsjs',
  HTML5 = 'html5',
  JW = 'jw',
  RADIANT = 'radiant',
  SHAKA = 'shaka',
  THEOPLAYER = 'theoplayer',
  VIDEOJS = 'videojs',
}
